import { Compact, CompactRow, FieldLabel, FieldSelectMulti } from '@newageerp/v3.bundles.form-bundle'
import { useURequest } from '@newageerp/v3.bundles.hooks-bundle';
import React, { useEffect } from 'react'

type Props = {
    skuPlans: string[],
    setSkuPlans: (v: string[]) => void,
}

export default function PlanSkuFilter(props: Props) {
    const t = (e: string) => e;
    
    const { skuPlans, setSkuPlans } = props;

    const [doReq, reqData] = useURequest<string>("/app/plugins/Reports/ReportsFilter/distintPlanSku");

    useEffect(() => {
        doReq({})
    }, []);

    return (
        <Compact>
            <CompactRow
                label={<FieldLabel>{t('Plan sku')}</FieldLabel>}
                control={
                    <FieldSelectMulti
                        value={skuPlans}
                        onChange={setSkuPlans}
                        options={[
                            ...reqData.data.data.map(s => {
                                return (
                                    {
                                        label: s,
                                        value: s,
                                    }
                                )
                            }),
                        ]}
                        asString={true}
                        allowSelectAll={true}
                    />
                }
            />
        </Compact>
    )
}
